// extracted by mini-css-extract-plugin
module.exports = {"HotBundles":"AUHotBundles_HotBundles__xIJhM","BestSellers":"AUHotBundles_BestSellers__vSfcT"};